var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegoMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 62,
    viewBox: "0 0 166 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rego-shield-1",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2B378C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51%",
    stopColor: "#2E3285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86%",
    stopColor: "#372C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3D2A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rego-shield-2",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "7%",
    stopColor: "#882783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#314196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "93%",
    stopColor: "#364F9F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rego-shield-3",
    cx: "37%",
    cy: "43%",
    r: "81%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#261E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#455CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#261E58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rego-shield-4",
    cx: "40%",
    cy: "38%",
    r: "76%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D684B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#832573"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rego-shield-5",
    cx: "18%",
    cy: "56%",
    r: "58%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#372D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#455CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#455CA4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rego-shield-6",
    cx: "74%",
    cy: "67%",
    r: "56%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#842573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D684B7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rego-tick-shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1,
    floodColor: "#000000",
    floodOpacity: 0.47
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 30C11.5 28.6 8 24.8 6.5 20.5C5.6 18.2 5.1 15.7 4.8 13.2C4.8 12.6 4.4 6.4 4.7 6.4C8.7 6.3 12.6 5.3 16 3",
    fill: "url(#rego-shield-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 30C20.5 28.6 24 24.8 25.5 20.5C26.4 18.2 26.9 15.7 27.2 13.2C27.2 12.6 27.6 6.4 27.3 6.4C23.3 6.3 19.4 5.3 16 3",
    fill: "url(#rego-shield-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7 6.4C4.7 6.4 7.2 6.4 10 5.7C10 5.7 10.1 18 16 21.5V30C16 30 4.6 27.7 4.6 8C4.6 6.3 4.7 6.4 4.7 6.4Z",
    fill: "url(#rego-shield-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 6.4C26.7 6.3 24.9 6.4 22 5.7C22 5.7 21.9 18 16 21.5V30C16 30 27.5 27.4 27.4 8C27.4 7.9 27.4 7.8 27.4 7.7C27.4 6.4 27.3 6.4 27.3 6.4Z",
    fill: "url(#rego-shield-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7 6.4C4.7 6.4 7.2 6.4 10 5.7C10 5.7 10.1 18 16 21.5V30C16 30 4.6 27.7 4.6 8C4.6 6.3 4.7 6.4 4.7 6.4Z",
    fill: "url(#rego-shield-5)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 6.4C26.7 6.3 24.9 6.4 22 5.7C22 5.7 21.9 18 16 21.5V30C16 30 27.5 27.4 27.4 8C27.4 7.9 27.4 7.8 27.4 7.7C27.4 6.4 27.3 6.4 27.3 6.4Z",
    fill: "url(#rego-shield-6)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.5L22.6 11.7C21.2 13 19.9 14.4 18.7 15.9C17 18.3 15.4 21 14 23.8H13.8L9.8 18.9L9.9 18.7H10L13.4 20.6C14.8 18.7 16.3 16.8 18 15.2C18.8 14.4 19.6 13.7 20.4 13C21.2 12.4 21.9 11.9 22.5 11.5Z",
    fill: "#FFFFFF",
    filter: "url(#rego-tick-shadow)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 42,
    fontFamily: "Roboto, 'Segoe UI', system-ui, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#102250"
  }, "RegO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegoMainLogo);
export default __webpack_public_path__ + "static/media/Rego_Main_Logo.bac10bf55fde513b2eb05207c7ab14b4.svg";
export { ForwardRef as ReactComponent };